import React from "react";
import ReadOnlyEditor from "../Editor/ReadOnlyEditor";

const FeedDetailComponent = props => {
  console.log(props);

  return (
    <div className="container-detail-page">
      <div className="post-image">
        <img
          src={props.feed_detail_page_image.file}
          alt="feed-detail"
          className="responsive-image"
        />
      </div>
      <div className="post-content-detail">
        <h2>{props.feed_brief}</h2>
        <div>
          <ReadOnlyEditor editorState={props.editorState} />
        </div>
        <small
          className="post-time-mob"
          style={{ padding: "10px 0", marginBottom: "0px" }}
        >
          4 min read • 19 Jan, 2019
        </small>
      </div>
      <div>
        <a href="#" className="btn-read-more-detail">
          Share Now
        </a>
      </div>
    </div>
  );
};

export default FeedDetailComponent;
